export default __webpack_public_path__ + "static/media/0168.92741248.jpg";